module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAWBAMAAAC8tehJAAAAHlBMVEUAK3////8zVZlObKbm6/Lb4e36+/1adqz56BS7ui5zkN/CAAAALklEQVR4AWMgCjBiiCgKoIswO2DqYyXCpEQMEYECBvqADjTQgEVkJhqYQDvnAABHUh19QfErZQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/cw.png
// module id = 806
// module chunks = 0